import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function WaterBill({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="28"
      height="30"
      viewBox="0 0 28 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform={transform}
      className={cn("h-6 w-6", className)}
      {...reset}
    >
      <g filter="url(#water_bill_icon)">
        <path
          d="M20.5 2.25H5.5C5.03604 2.25056 4.59125 2.43512 4.26319 2.76319C3.93512 3.09125 3.75056 3.53604 3.75 4V22.4507C3.74997 22.6425 3.80517 22.8304 3.90899 22.9917C4.01281 23.1531 4.16088 23.2812 4.33551 23.3606C4.51014 23.4401 4.70395 23.4677 4.89382 23.44C5.08368 23.4123 5.26157 23.3306 5.40625 23.2046L6.62305 22.1455L8.084 23.4194C8.26607 23.5788 8.49967 23.6669 8.74166 23.6675C8.98364 23.668 9.21764 23.5809 9.40041 23.4224L10.8652 22.1445L12.335 23.4238C12.5175 23.5808 12.7502 23.667 12.9909 23.6669C13.2316 23.6667 13.4643 23.5801 13.6465 23.4228L15.1152 22.144L16.5879 23.4257C16.7706 23.5814 17.003 23.6668 17.243 23.6664C17.4831 23.6661 17.7152 23.58 17.8975 23.4237L19.3711 22.1435L20.5947 23.2065C20.7395 23.3322 20.9174 23.4136 21.1072 23.4411C21.2969 23.4685 21.4906 23.4408 21.665 23.3613C21.8395 23.2817 21.9874 23.1537 22.0911 22.9924C22.1948 22.8311 22.25 22.6434 22.25 22.4517V4C22.2494 3.53604 22.0649 3.09125 21.7368 2.76319C21.4087 2.43512 20.964 2.25056 20.5 2.25Z"
          fill="url(#paint0_linear_293_56244)"
        />
        <path
          d="M7.75 8.5C8.16421 8.5 8.5 8.16421 8.5 7.75C8.5 7.33579 8.16421 7 7.75 7C7.33579 7 7 7.33579 7 7.75C7 8.16421 7.33579 8.5 7.75 8.5Z"
          fill="white"
        />
        <path
          d="M7.75 12.5C8.16421 12.5 8.5 12.1642 8.5 11.75C8.5 11.3358 8.16421 11 7.75 11C7.33579 11 7 11.3358 7 11.75C7 12.1642 7.33579 12.5 7.75 12.5Z"
          fill="white"
        />
        <path
          d="M7.75 16.5C8.16421 16.5 8.5 16.1642 8.5 15.75C8.5 15.3358 8.16421 15 7.75 15C7.33579 15 7 15.3358 7 15.75C7 16.1642 7.33579 16.5 7.75 16.5Z"
          fill="white"
        />
        <path
          d="M18.25 8.5H10.25C10.0511 8.5 9.86032 8.42098 9.71967 8.28033C9.57902 8.13968 9.5 7.94891 9.5 7.75C9.5 7.55109 9.57902 7.36032 9.71967 7.21967C9.86032 7.07902 10.0511 7 10.25 7H18.25C18.4489 7 18.6397 7.07902 18.7803 7.21967C18.921 7.36032 19 7.55109 19 7.75C19 7.94891 18.921 8.13968 18.7803 8.28033C18.6397 8.42098 18.4489 8.5 18.25 8.5Z"
          fill="white"
        />
        <path
          d="M18.25 12.5H10.25C10.0511 12.5 9.86032 12.421 9.71967 12.2803C9.57902 12.1397 9.5 11.9489 9.5 11.75C9.5 11.5511 9.57902 11.3603 9.71967 11.2197C9.86032 11.079 10.0511 11 10.25 11H18.25C18.4489 11 18.6397 11.079 18.7803 11.2197C18.921 11.3603 19 11.5511 19 11.75C19 11.9489 18.921 12.1397 18.7803 12.2803C18.6397 12.421 18.4489 12.5 18.25 12.5Z"
          fill="white"
        />
        <path
          d="M18.25 16.5H10.25C10.0511 16.5 9.86032 16.421 9.71967 16.2803C9.57902 16.1397 9.5 15.9489 9.5 15.75C9.5 15.5511 9.57902 15.3603 9.71967 15.2197C9.86032 15.079 10.0511 15 10.25 15H18.25C18.4489 15 18.6397 15.079 18.7803 15.2197C18.921 15.3603 19 15.5511 19 15.75C19 15.9489 18.921 16.1397 18.7803 16.2803C18.6397 16.421 18.4489 16.5 18.25 16.5Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="water_bill_icon"
          x="-2"
          y="-1"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.231373 0 0 0 0 0.509804 0 0 0 0 0.964706 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_293_56244"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_293_56244"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_293_56244"
          x1="8.60625"
          y1="4.39175"
          x2="19.4244"
          y2="20.1299"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6AB8FF" />
          <stop offset="1" stopColor="#1A69DF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
